<template>
    <div
        :class="avatarClass"
        :style="avatarStyle"
    >
        <template v-if="!isLoading">
            <StreamlineIcon
                v-if="!useDefault"
                :icon="SingleNeutral"
                :stroke="white"
                class="RPUserAvatar__default-icon"
                :size="size"
            />
            <img
                v-else
                :src="avatar"
                alt="person_icon"
                class="RPUserAvatar__user-avatar"
                :style="avatarStyle"
            >
        </template>
    </div>
</template>
<script>
import {SingleNeutral} from '@reviewpush/streamline-regular/lib/users/GeomerticCloseUpSingleUserNeutral';
import StreamlineIcon from "@reviewpush/streamline-icons-vue";
import {white} from 'style/_colors.scss';
import stat from 'status';
import statusBuilder from 'status/statusBuilder';

export default {
    name: 'RPUserAvatar',
    components: {
        StreamlineIcon
    },
    props: {
        avatar: {
            type: [String, Boolean],
            default: ''
        },
        size: {
            type: Number,
            default: 32
        },
        /**
       * A status pulled from the common `status` constants (`/src/status/index.js`)
       */
        status: {
            type: String,
            default: stat.STANDBY,
        }

    },
    data(){
        return {
            SingleNeutral,
            white,
        };
    },
    computed: {
        useDefault(){
            return this.avatar === '' || (typeof this.avatar === 'boolean' && !this.avatar);
        },
        avatarClass(){
            return statusBuilder('RPUserAvatar', this.status);
        },
        avatarStyle(){
            return {
                'height': `${this.size}px`,
                'width': `${this.size}px`,
            };
        },
        isLoading(){
            return this.status === stat.LOADING;
        }
    }
};
</script>
<style lang="scss">
    .RPUserAvatar {
        overflow: hidden;
        background: $text-grey;
        border-radius: 90%;
        display: flex;
        align-items: center;
        justify-content: center;

        @include loading(2rem, 2rem, 90%);

        &__default-icon {
            opacity: .5;
        }

        &__user-avatar {
            border-radius: 90%;
        }
    }
</style>

<docs>
    ```vue
    <RPUserAvatar></RPUserAvatar>
    ```
    ```vue
    <RPUserAvatar status="loading"></RPUserAvatar>
    ```
    ```vue
    <RPUserAvatar avatar="https://www.iconspng.com/images/linux-avatar/linux-avatar.jpg"></RPUserAvatar>
    ```
</docs>
